export const LeaseListingTeamLeadDashboardPermissions = {
  LeaseListingTeamLeadDashboard: 
    {
      permissionsId:'dd8fec2f-6b29-4b00-6831-08da421d6e99',
      permissionsName :'Lease Listing Team Lead Dashboard"',
      componentsId:null,
      components:null , 
    }
} ;
